import contactModalWrapper from './contactModal';

const contactButtonElm = document.querySelector('#contact-modal-button');

const contactModalFloatingButton = {
	
	registerEvents: () => {
		window.addEventListener('scroll', contactModalFloatingButton.handleScroll);
	},
	
	handleScroll: () => {
		if (window.scrollY + window.innerHeight >= document.body.scrollHeight) {
			contactButtonElm.classList.add('scrolled-to-bottom');
		} else {
			contactButtonElm.classList.remove('scrolled-to-bottom');
		}
	},
	
	init: () => {
		if (!contactButtonElm) return;
		
		contactModalFloatingButton.registerEvents();
		contactModalWrapper.init();
		
		contactButtonElm.addEventListener('click', function (e) {
			e.preventDefault();
			contactModalWrapper.init();
			contactModalWrapper.handleOpen();
			
		});
		
	}
	
};

export default contactModalFloatingButton;
